import { render } from "./abdoutus.vue?vue&type=template&id=1ccdfb09&scoped=true"
import script from "./abdoutus.vue?vue&type=script&lang=js"
export * from "./abdoutus.vue?vue&type=script&lang=js"

import "./abdoutus.vue?vue&type=style&index=0&id=1ccdfb09&scoped=true&lang=css"

import exportComponent from "/home/kira/project/web/SPACDYNA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ccdfb09"]])

export default __exports__